import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { ErrorMessage as ErrorMessageContainer } from '@hookform/error-message';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import { ErrorMessage } from '../Enquiry';
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import {
  Button,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import Tip from 'venuescanner-js/react/components/Inbox/components/Objects/Tip';
import EnquiryCtas from '../EnquiryCtas';
import './ConfirmBookingPrice.scss';

function ConfirmBookingPrice({ send }) {
  const { activeCurrency, activeThread } = useContext(ViewContext);
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm({
    mode: 'onChange',
    criteriaMode: 'all',
    defaultValues: {
      price: activeThread?.data()?.budget,
    },
  });

  const onSubmit = formValues => {
    send({ type: 'CONFIRM_PRICE', price: formValues.price });
  };

  return (
    <>
      <form
        id='confirm-price-form'
        className='enquiry enquiry-details'
        onSubmit={handleSubmit(onSubmit)}>
        <Stack
          alignItems='center'
          spacing={1.5}
          direction='row'
          sx={{ mb: 1.5 }}>
          <IconButton
            onClick={() => {
              send({ type: 'BACK' });
            }}
            sx={{
              width: 18,
              height: 18,
              transform: 'rotate(90deg)',
              color: '#1E0040',
            }}>
            <ExpandCircleDownOutlinedIcon />
          </IconButton>
          <h1 className='enquiry__header-title'>Price</h1>
        </Stack>
        <Stack className='enquiry-info' spacing={2} direction='column'>
          <Typography variant='body1' sx={{ fontSize: 16, color: '#000' }}>
            Total cost to organiser
          </Typography>
          <Typography variant='body2' sx={{ fontSize: 13, color: '#000' }}>
            This has been pre filled in from your quote, if it has changed for
            any reason you can update it here.
          </Typography>
          <TextField
            size='small'
            variant='outlined'
            sx={{
              '& .MuiInputBase-root': {
                paddingLeft: 1.25,
                fontSize: 14,
                background: '#fff',
                mb: 0.5,
              },
              '& .MuiInputBase-input': { color: '#000' },
              '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: 1,
                top: -10,
                borderColor: '#7E8CAB',
                borderWidth: '0.5px',
              },
            }}
            InputProps={{
              id: 'price',
              type: 'number',
              startAdornment: (
                <InputAdornment sx={{ color: '#000' }} position='start'>
                  {activeCurrency.currency.symbol}
                </InputAdornment>
              ),
              ...register('price', {
                min: { value: 1, message: 'Please enter an amount' },
              }),
            }}
          />
        </Stack>
        <ErrorMessageContainer errors={errors} name='price' as={ErrorMessage} />
        <EnquiryCtas sx={{ mt: 'auto' }}>
          <Button
            variant='contained'
            type='submit'
            size='medium-large'
            form='confirm-price-form'
            color='primary'
            fullWidth>
            Confirm booking
          </Button>
          <Button
            size='medium-large'
            fullWidth
            variant='outlined'
            color='primary'
            onClick={() => send({ type: 'SKIP_PRICE_CONFIRMATION' })}>
            Skip step
          </Button>
          <Button
            size='medium-large'
            fullWidth
            variant='text'
            color='primary'
            onClick={() => send({ type: 'CLOSE' })}>
            Close enquiry
          </Button>
          <Tip
            title='Tip'
            text='When you mark an enquiry as booked your venue gets a higher search ranking'
          />
        </EnquiryCtas>
      </form>
    </>
  );
}

export default ConfirmBookingPrice;
